import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  ramais: [],
  agendamentoSelecionado: [],
  integracoes: [],
  troncos: [],
  tags: [],
  segware:[],
  audios:[],
  ia:[],
  operador:[],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
